import { useDispatch } from "react-redux";
import TextInput from "../../../../../../components/inputs/textInput/TextInput";
import Loader from "../../../../../../components/loader/Loader";
import Dialog from "../../../../../../components/dialog/Dialog";
import { addPlayerToTournament } from "../../../../../../features/players/playersSlice";
import styles from "./addPlayer.module.css";
import OnePlayer from "./onePlayer/OnePlayer";

const AddPlayer = ({
  onClose,
  value,
  onChange,
  loading,
  players,
  gameName,
  tournamentId,
  tableId,
  tournamentType = "solo",
}) => {
  const dispatch = useDispatch();

  return (
    <Dialog
      title={
        tournamentType === "squad"
          ? "اضافة فريق الى الجدول"
          : "اضافة لاعب الى الجدول"
      }
      size="md"
      onClose={onClose}
      closeOnEscape
      closeOnBackdrop
      // The result rows were laid out inside the table's left-to-right block.
      bodyDir="ltr"
    >
      <div className={styles.addNewPlayerModalWrapper}>
        <TextInput
          height="50px"
          width="100%"
          borderRadius="10px"
          placeHolder={
            tournamentType === "squad" ? "البحث عن فريق" : "البحث عن لاعب"
          }
          bgColor={"grey"}
          value={value}
          onChange={(e) => onChange(e)}
          data-no-select-box
        />
        <div className={styles.playersWrapper}>
          {loading ? (
            <Loader />
          ) : (
            players?.map((player) => {
              return (
                <OnePlayer
                  player={player}
                  gameName={gameName}
                  tournamentType={tournamentType}
                  key={player._id}
                  onClick={() => {
                    dispatch(
                      addPlayerToTournament({
                        kind: tournamentType === "squad" ? "squad" : "user",
                        userId: tournamentType === "squad" ? null : player?._id,
                        squadId:
                          tournamentType === "squad" ? player?._id : null,
                        tableId,
                        tournamentId,
                      }),
                    );
                    onClose();
                  }}
                />
              );
            })
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default AddPlayer;
